import React from "react";

export default function TeacherDetailNotesSection({ teacher, userProfile }) {
  const currentMemberRole = userProfile?.memberRole;
  const isLinkedUser =
    userProfile?.uid &&
    teacher.linkedUserId &&
    String(teacher.linkedUserId) === String(userProfile.uid);
  const isMyProfile = isLinkedUser;
  const shouldMask = currentMemberRole === "teacher" && !isMyProfile;

  return (
    <div className="w-full mb-8">
      <h3 className="text-xl font-bold text-gray-900 mb-4 px-1">메모</h3>
      <div className="bg-[#FFF9E5] p-6 rounded-3xl text-gray-800 font-medium leading-relaxed shadow-sm">
        {shouldMask ? (
          <span className="blur-[5px] select-none text-gray-400">메모 내용이 가려져 있습니다.</span>
        ) : (
          teacher.notes || "특이사항이 없습니다."
        )}
      </div>
    </div>
  );
}
